module.exports = __webpack_public_path__ + "img/gongzhong.a9e5bfdb.png";